import styled from 'styled-components';

import { StyledContainer } from '../../shared/styled-components/styled-container.style';

export const StyledMapContainer = styled(StyledContainer)`
  position: relative;
  overflow: hidden;
`;

